
import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const CoursesPage = lazy(() => import('../pages/courses/page'));
const CourseDetailPage = lazy(() => import('../pages/course-detail/page'));
const CourseDetailNewPage = lazy(() => import('../pages/course-detail-new/page'));
const LearningPage = lazy(() => import('../pages/learning/page'));
const LearnNewPage = lazy(() => import('../pages/learn/page-new'));
const MyPageLearnPage = lazy(() => import('../pages/mypage-learn/page'));
const MyPage = lazy(() => import('../pages/my/page'));
const ExamPage = lazy(() => import('../pages/exam/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const AdminMembersPage = lazy(() => import('../pages/admin/members/page'));
const AdminCourseManagementPage = lazy(() => import('../pages/admin/course-management/page'));
const AdminExamManagementPage = lazy(() => import('../pages/admin/exam-management/page'));
const AdminCourseEditPage = lazy(() => import('../pages/admin/course-edit/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    lazy: () => import('../pages/home/page'),
  },
  {
    path: '/courses',
    lazy: () => import('../pages/courses/page'),
  },
  {
    path: '/course/:id',
    lazy: () => import('../pages/course-detail/page'),
  },
  {
    path: '/course-new/:code',
    lazy: () => import('../pages/course-detail-new/page'),
  },
  {
    path: '/learning/:courseId',
    lazy: () => import('../pages/learning/page'),
  },
  {
    path: '/learn/:code',
    lazy: () => import('../pages/learn/page-new'),
  },
  {
    path: '/mypage/learn',
    lazy: () => import('../pages/mypage-learn/page'),
  },
  {
    path: '/my',
    lazy: () => import('../pages/my/page'),
  },
  {
    path: '/exam/:examId',
    lazy: () => import('../pages/exam/page'),
  },
  {
    path: '/admin',
    lazy: () => import('../pages/admin/page'),
  },
  {
    path: '/admin/members',
    lazy: () => import('../pages/admin/members/page'),
  },
  {
    path: '/admin/courses',
    lazy: () => import('../pages/admin/course-management/page'),
  },
  {
    path: '/admin/courses/edit/:id',
    lazy: () => import('../pages/admin/course-edit/page'),
  },
  {
    path: '/admin/exams',
    lazy: () => import('../pages/admin/exam-management/page'),
  },
  {
    path: '*',
    lazy: () => import('../pages/NotFound'),
  },
];

export default routes;
